import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-task-qa",
  "use": "icon-ib-task-qa-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-task-qa\"><path d=\"M384 181.333333a32 32 0 0 1 32 32v568.874667a32 32 0 0 1-64 0V213.333333A32 32 0 0 1 384 181.333333z\" p-id=\"8159\" /><path d=\"M352 213.333333A32 32 0 0 1 384 181.333333h170.666667a202.666667 202.666667 0 1 1 0 405.333334H384a32 32 0 0 1 0-64h170.666667a138.666667 138.666667 0 1 0 0-277.333334H384A32 32 0 0 1 352 213.333333z\" p-id=\"8160\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol